<div class="customers" >

    <div class="card">
        <div class="card-body" style="padding: 20px;">

            <div class="row">
                

                <div class="row mt-3">
                    <div class="col-sm-12">
                        <h2>BIBLIOTECA</h2>
                        <p>Bienvenida a este espacio donde podrá revisar la distinta documentación asociada al jardín infantil.</p>

                        <br>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="divTutoria">
                            <div class="row">
                                <div class="col-sm-2">
                                    <div class="imgContainer">
                                        <img src="../../../../../assets/icons/ico_induccion.png">
                                    </div>
                                </div>
                                <div class="col-sm-8">

                                    <h4>Sección de documentos Generales</h4>
                                    <p class="dataSubGreen" style="cursor: pointer;" (click)="collapse1.toggle()">Documentación General</p>
                                </div>

                                <div class="col-sm-2" style="text-align: right;">
                                    <img src="../../../../../assets/icons/JUNJI__green-plus.svg" *ngIf="isCollapsed1" alt="avatar" style="width: 50px;margin-top: 0px;cursor: pointer;" (click)="collapse1.toggle()" [attr.aria-expanded]="!isCollapsed1" aria-controls="collapseExample">
                                    <img src="../../../../../assets/icons/JUNJI__green-less.svg" *ngIf="!isCollapsed1" alt="avatar" style="width: 50px;margin-top: 0px;cursor: pointer;" (click)="collapse1.toggle()" [attr.aria-expanded]="!isCollapsed1" aria-controls="collapseExample">
                                </div>

                                <div class="row mt-2" #collapse1="ngbCollapse" [(ngbCollapse)]="isCollapsed1">

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <p class="content">Documentos</p>
                                        </div>
                                    </div>

                                    <div *ngFor="let archivo of archivosGenerales; let indice=index" class="col-sm-12 divContainerData">
                                        <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                        <p (click)="verDocumento(archivo)" class="dataFecha docTitle"> {{archivo.fileName}} </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="divTutoria">
                            <div class="row">
                                <div class="col-sm-2">
                                    <div class="imgContainer">
                                        <img src="../../../../../assets/icons/ico_reu-validacion.png">
                                    </div>
                                </div>
                                <div class="col-sm-8">

                                    <h4>Documentos del Jardín Infantil</h4>
                                    <p class="dataSubGreen" style="cursor: pointer;" (click)="collapse4.toggle()">Documentación Especifica</p>
                                </div>

                                

                                <div class="col-sm-2" style="text-align: right;">
                                    <img src="../../../../../assets/icons/JUNJI__green-plus.svg" *ngIf="isCollapsed4" alt="avatar" style="width: 50px;margin-top: 0px;cursor: pointer;" (click)="collapse4.toggle()" [attr.aria-expanded]="!isCollapsed4" aria-controls="collapse4">
                                    <img src="../../../../../assets/icons/JUNJI__green-less.svg" *ngIf="!isCollapsed4" alt="avatar" style="width: 50px;margin-top: 0px;cursor: pointer;" (click)="collapse4.toggle()" [attr.aria-expanded]="!isCollapsed4" aria-controls="collapse4">
                                </div>

                                <div class="row mt-2" #collapse4="ngbCollapse" [(ngbCollapse)]="isCollapsed4">
                                    <div class="row">
                                        <div class="row">

                                          

                                            <div class="row ">
                                                <div class="col-sm-12">
                                                    <p class="content">Documentos</p>
                                                </div>
                                            </div>

                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                <p (click)="verDocumentoJardin('pei2023')" class="dataFecha docTitle"> Proyecto Educativo Institucional 2023</p>
                                            </div>

                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                <p (click)="verDocumentoJardin('pei2024')" class="dataFecha docTitle"> Proyecto Educativo Institucional 2024</p>
                                            </div>

                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                <p (click)="verDocumentoJardin('pei2025')" class="dataFecha docTitle"> Proyecto Educativo Institucional 2025</p>
                                            </div>
                                            
                                         

                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                <p (click)="verDocumentoJardin('plan-mejora')" class="dataFecha docTitle"> Plan de Mejoramiento 2023</p>
                                            </div>

                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                <p (click)="downloadExcel()" class="dataFecha docTitle">Plan de Mejoramiento 2024 </p>
                                                <!--a [attr.href]="urlInformeExcelPME1"  class="dataFecha docTitle" target="_blank">Plan de Mejoramiento 2024</a-->
                                            </div>
                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                <p (click)="downloadExcel2025()" class="dataFecha docTitle">Plan de Mejoramiento 2025 </p>
                                                <!--a [attr.href]="urlInformeExcelPME1"  class="dataFecha docTitle" target="_blank">Plan de Mejoramiento 2024</a-->
                                            </div>

                                            <!--div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                <a [attr.href]="urlInformeExcelPME2"  class="dataFecha docTitle" target="_blank">Plan de Mejoramiento 2025</a>
                                            </div-->

                                            <div class="col-sm-12 divContainerData" *ngIf="pgc2023">
                                                <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                <p (click)="verDocumentoJardin('plan-convivencia-2023')" class="dataFecha docTitle"> Plan de Gestión de la Convivencia 2023 </p>
                                            </div>

                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                <p (click)="verDocumentoJardin('plan-convivencia2024')" class="dataFecha docTitle"> Plan de Gestión de la Convivencia 2024 </p>
                                            </div>

                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                <p (click)="verDocumentoJardin('plan-convivencia2025')" class="dataFecha docTitle"> Plan de Gestión de la Convivencia 2025 </p>
                                            </div>

                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                <p (click)="verDocumentoJardin('reglamento')" class="dataFecha docTitle"> Reglamento Interno </p>
                                            </div>

                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                <p (click)="verDocumentoJardin('autoevaluacion2024')" class="dataFecha docTitle"> Instrumento de Autoevaluación 2024</p>
                                            </div>

                                        </div>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                
            </div>

            </div>
        </div>
    </div>

    <!--ng-template #modalInforme let-modal class="modal-dialog modal-xl">
        <div class="modal-header" style="padding: 0px " width="100%">
            <h5 id="modalTitleUser" class="titulo-card-amarillo" style="    margin: 25px">Documento</h5>
            <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
              <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" style="padding: 0px;" width="100%">
            <iframe [src]="urlSafe" frameborder="0" width="100%" style="min-height: 700px;" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen> </iframe>
        </div>
    </ng-template-->
    

    <ngx-spinner></ngx-spinner>